import { createElement, type FC } from 'react'

type Icon = FC<{ className?: string }>
const icon = (d: string): Icon => ({ className }) =>
  createElement(
    'svg',
    {
      className,
      viewBox: '0 0 24 24',
      width: 24,
      height: 24,
      overflow: 'visible',
      fill: 'none',
      stroke: 'currentColor',
      strokeWidth: 1.8,
      strokeLinecap: 'round',
      strokeLinejoin: 'round',
    },
    createElement('path', { d }),
  )

export const OpenIcon = icon('M5 19 19 5M9 5h10v10')
export const RescheduleIcon = icon('M4 7h16M7 3v4m10-4v4M5 5h14v15H5zM9 12h3l2 2')
export const PingIcon = icon('M12 3a9 9 0 1 1-9 9M12 7v5l3 2')
export const AssignIcon = icon('M16 21v-2a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4v2M9.5 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m7.5-2v6m-3-3h6')
export const RemoveIcon = icon('M4 7h16M10 11v6m4-6v6M6 7l1 14h10l1-14M9 7V4h6v3')
export const ConvertToTaskIcon = icon('M5 4h14v16H5zM8 9h8M8 13h5m3 4 3-3-3-3')
export const ChangeTypeIcon = icon('M5 5h14M9 5v14m-4 0h8m4-12-5 5')
export const RequiredIcon = icon('m12 5 .8 4.2L17 7l-3 3.3L18 12l-4 1.7L17 17l-4.2-2.2L12 19l-.8-4.2L7 17l3-3.3L6 12l4-1.7L7 7l4.2 2.2z')
export const CollapseIcon = icon('M5 5h14M8 10l4 4 4-4M5 19h14')
export const SetRulesIcon = icon('M4 7h16M7 4v6m10-6v6M4 17h16m-5-3v6')
export const PreviewIcon = icon('M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12m10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6')
export const AddFieldIcon = icon('M5 4h10v16H5zM8 8h4M8 12h4m6-2v8m-4-4h8')
export const AddSectionIcon = icon('M4 5h16v5H4zm0 9h9m4-3v8m-4-4h8')
export const ChangeRoleIcon = icon('M8 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8m-5 10v-2a5 5 0 0 1 10 0v2m4-10h4m-2-2 2 2-2 2')
export const CycleRoleIcon = icon('M19 8a7 7 0 1 0 1 7M19 4v4h-4m-5 3a2 2 0 1 0 0-4 2 2 0 0 0 0 4')
export const DetachIcon = icon('m9 15-2 2a4 4 0 0 1-6-6l3-3a4 4 0 0 1 6 0m5-1 2-2a4 4 0 0 1 6 6l-3 3a4 4 0 0 1-6 0M8 16l8-8')
export const NewNodeIcon = icon('M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18m0 5v8m-4-4h8')
export const ReflowIcon = icon('M4 7h12l-3-3m3 3-3 3M20 17H8l3 3m-3-3 3-3')
